import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { HomeOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import './main.css';

function NotFoundPage() {
    return (
        <div className="not-found-page">
            <div className="not-found-content">
                {/* Animated 404 */}
                <div className="not-found-code">
                    <span className="digit" data-text="4">4</span>
                    <span className="digit zero" data-text="0">0</span>
                    <span className="digit" data-text="4">4</span>
                </div>

                {/* Message */}
                <h1 className="not-found-title" data-text="Page Not Found">Page Not Found</h1>
                <p className="not-found-subtitle">
                    Oops! The page you're looking for doesn't exist or has been moved.
                </p>

                {/* Action Buttons */}
                <div className="not-found-actions">
                    <Link to="/">
                        <Button
                            type="primary"
                            size="large"
                            icon={<HomeOutlined />}
                            className="not-found-btn primary"
                        >
                            Go to Home
                        </Button>
                    </Link>
                    <Button
                        size="large"
                        icon={<ArrowLeftOutlined />}
                        onClick={() => window.history.back()}
                        className="not-found-btn secondary"
                    >
                        Go Back
                    </Button>
                </div>
            </div>

            {/* Decorative elements */}
            <div className="not-found-decoration">
                <div className="floating-shape shape-1"></div>
                <div className="floating-shape shape-2"></div>
                <div className="floating-shape shape-3"></div>
            </div>
        </div>
    );
}

export default NotFoundPage;
